import SearchIcon from "@mui/icons-material/Search";
import { Box, Button, Typography } from "@mui/material";
import type { FC, ReactNode } from "react";
import DatePickerV2 from "../../../components/datePicker/DatePickerV2";
import dayjs, { ISO_DATE_FORMAT } from "../../../dayjs";

export interface ReportDateRange {
  readonly from: string;
  readonly to: string;
}

interface Props {
  /** The report's subject picker (sellers, customer or provider), rendered full-width above the dates. */
  readonly subject: ReactNode;
  readonly dateLabel: string;
  readonly range: ReportDateRange;
  readonly onRangeChange: (range: ReportDateRange) => void;
  readonly onApply: () => void;
  readonly applyDisabled: boolean;
  /** Summary of the currently applied filters, shown as a caption under the panel. */
  readonly activeFilters?: string;
}

const ReportFilterPanel: FC<Props> = ({
  subject,
  dateLabel,
  range,
  onRangeChange,
  onApply,
  applyDisabled,
  activeFilters,
}) => (
  <>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
        gap: 2,
        mb: activeFilters ? 1 : 3,
        p: 2,
        bgcolor: "rgba(0,0,0,0.02)",
        borderRadius: 2,
        border: "1px solid rgba(0,0,0,0.06)",
      }}
    >
      <Box sx={{ gridColumn: { xs: "1", sm: "1 / -1" } }}>{subject}</Box>
      <DatePickerV2
        label={`${dateLabel} — od`}
        size="small"
        fullWidth
        value={range.from ? dayjs(range.from, ISO_DATE_FORMAT) : null}
        onChange={(date) => onRangeChange({ ...range, from: date?.format(ISO_DATE_FORMAT) ?? "" })}
      />
      <DatePickerV2
        label={`${dateLabel} — do`}
        size="small"
        fullWidth
        value={range.to ? dayjs(range.to, ISO_DATE_FORMAT) : null}
        onChange={(date) => onRangeChange({ ...range, to: date?.format(ISO_DATE_FORMAT) ?? "" })}
      />
      <Box sx={{ gridColumn: { xs: "1", sm: "1 / -1" }, display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" size="small" startIcon={<SearchIcon />} onClick={onApply} disabled={applyDisabled}>
          Zastosuj filtry
        </Button>
      </Box>
    </Box>
    {activeFilters && (
      <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mb: 2 }}>
        Aktywne filtry: {activeFilters}
      </Typography>
    )}
  </>
);

export default ReportFilterPanel;
